import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UncontrolledTooltip } from 'reactstrap';
import { OperationEsrr } from '../../../../services/types/Esrr';
import { tooltipPreventOverflowModifiers } from '../../../../shared/misc/utils';

interface Props {
  x: OperationEsrr;
}

const EsrrTooltip: React.FC<Props> = ({ x }) => {
  const { t } = useTranslation();
  return x.toolkit &&
    x.toolkit.esrr !== null &&
    x.toolkit.esrrCalculated !== null &&
    x.toolkit.esrr !== x.toolkit.esrrCalculated ? (
    <div className="esrr-badge esrr-info">
      <span id={`esrr_icon_${x.id}`} className="esrr-info_icon">
        <FontAwesomeIcon icon="info-circle" />
      </span>
      <span> Changed</span>
      <UncontrolledTooltip
        className="tooltip-impact"
        placement="bottom"
        target={`esrr_icon_${x.id}`}
        modifiers={tooltipPreventOverflowModifiers}
      >
        <p>
          <b>
            {t('categoryChangedTooltip', {
              catCalculated: x.toolkit.esrrCalculated ? x.toolkit.esrrCalculated : '',
              cat: x.toolkit.esrr ? x.toolkit.esrr : '',
              by: x.toolkit.pdfCreatedBy,
            })}
          </b>
        </p>
        <p>
          {t('rationale')}: <i>{x.toolkit.esrrRationale}</i>
        </p>
        <p>
          {t('comments')}: <i>{x.toolkit.esrrComments}</i>
        </p>
      </UncontrolledTooltip>
    </div>
  ) : null;
};

export default EsrrTooltip;
